import AppcuesWidget from 'components/appcues/appcues-widget'
import ProfilePopover from 'components/profile/profile-popover'
import CreateSnapshot from 'components/snapshots/create-snapshot'
import { WithTip } from 'components/tooltip/with-tip'
import { BugTag } from 'components/wrapper/header/bug-tag'
import CalcButton from 'components/wrapper/header/calc'
// Styled Components
import { HeaderIcon_s, HeaderMiddle_s, HeaderRight_s, Header_s, Logo_s } from 'components/wrapper/header/header-styles'
import NewNotifications from "components/wrapper/header/notifications"
// Components
import NewCalc from 'components/wrapper/header/new-calc'
import PropertySelection from 'components/wrapper/header/property-selection'
import PropertyUnderwriting from 'components/wrapper/header/property-underwriting'
import Notifications from 'components/wrapper/notifications'
import ReadOnly from 'components/wrapper/header/read-only'
// Data
import authService from "data/auth"
import { local } from 'data/lib/local-json'
import toggles from 'feature-toggles'
import { isReportOnly } from 'data/lib/report-only'
// Icons
import { rDCFLogo } from 'images/'
import { LogoutIcon } from 'images/icons/header'
import React from 'react'
import Isvg from 'react-inlinesvg'

class Header extends React.Component {

  render (){
    const appMode = local('appMode');

    return (
      <Header_s id="rdcf-header">
        <Logo_s onClick={() => window.location.replace("/dashboard")}><img src={rDCFLogo} /></Logo_s>
        {isReportOnly() && <ReadOnly />}
        { !appMode || appMode !== 'asset' ?
          <HeaderMiddle_s>
            <BugTag/>
            <PropertySelection />
            <CreateSnapshot type="property"/>
            <HeaderIcon_s>
              <PropertyUnderwriting />
            </HeaderIcon_s>
            <NewCalc />
            <CalcButton />
          </HeaderMiddle_s> : null
        }
        <HeaderRight_s>
          {toggles.notifications() && <NewNotifications />}
          <HeaderIcon_s>
            <Notifications />
            <AppcuesWidget />
          </HeaderIcon_s>
          <ProfilePopover />
          <HeaderIcon_s>
            <WithTip position="bottom">
              <span>Logout</span>
              <a onClick={()=>authService.logout()}><Isvg id="logoutIcon" src={LogoutIcon} /></a>
            </WithTip>
          </HeaderIcon_s>
        </HeaderRight_s>
      </Header_s>
    )
  }
}

export default Header;
